export default {
    placeholder: 'Поиск',
};
